import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import {
  CompetenciesEmployeesRootPageAssessmentFragment,
  CompetenciesProfileRootPageAssessmentFragment,
} from 'generated/resources/graphql'
import range from 'lodash/range'

interface CompetencyProps {
  assessment:
    | CompetenciesProfileRootPageAssessmentFragment
    | CompetenciesEmployeesRootPageAssessmentFragment
}

const CompetencyRating = ({ assessment }: CompetencyProps) => {
  const { scaleMin, scaleMax } = assessment

  const options = range(scaleMin, scaleMax + 1)

  return (
    <Box flexDirection="row" alignItems="center" flexGrow aria-label="assessment-competency-rating">
      {options.map((option) => {
        const isSelected = option === assessment.score

        return (
          <Box
            key={option}
            width="s40"
            height="s32"
            justifyContent="center"
            alignItems="center"
            borderRadius={{ all: 'abs008' }}
            background={isSelected ? 'grey800' : 'lighter000'}
          >
            <Text.Normal size="200" color={isSelected ? 'grey000White' : 'grey800'}>
              {option}
            </Text.Normal>
          </Box>
        )
      })}
    </Box>
  )
}

interface CompetencyRowProps {
  assessment:
    | CompetenciesProfileRootPageAssessmentFragment
    | CompetenciesEmployeesRootPageAssessmentFragment
}

const CompetencyRow = ({ assessment }: CompetencyRowProps) => {
  return (
    <Table.Row background={'grey000White'}>
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s32" padding="s16">
        <Box
          flexDirection="row"
          alignItems="center"
          width="s300"
          gap="s12"
          aria-label="assessment-competency-name"
        >
          <Box overflowY="auto" overflowX="hidden">
            <Text.Normal weight="medium" ellipsis>
              {assessment.competency?.name}
            </Text.Normal>
          </Box>
        </Box>
        {assessment && <CompetencyRating assessment={assessment} />}
      </Box>
    </Table.Row>
  )
}

export default CompetencyRow
